// import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { AllFoodOrderTableDataColumnType, AllFoodOrderTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const allLockerAssignTableData = [
    {
      foodOrderId: 1019,
      subTotalAmount: 100,
      gst: 5,
      grandTotalAmount: 399,
      status: "Ordered",
      ticketRFIdRef: "REF-SWP-2311",
      cardNumber: "1",
    },
    {
      foodOrderId: 1019,
      subTotalAmount: 100,
      gst: 5,
      grandTotalAmount: 399,
      status: "Ordered",
      ticketRFIdRef: "REF-SWP-2311",
      cardNumber: "1",
    }
];

// const ProductListTableAction = ({adultPlanId}) => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <button className="btn btn-sm">
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//       </button>
//       <p>{adultPlanId}</p>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
    try {
      await api.put(`/api/FoodOrder/UpdateFoodOrderStatus?foodOrderId=${id}`);
      Swal.fire('Update!', 'Status has updated successfully!!.', 'success');
  
      // Optional: refresh the list
    //   setCardAssignTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
    } catch (error) {
      Swal.fire('Error!', 'Failed to update order status.', 'error');
    //   console.error("Update error:", error);
    }
  };

interface ProductListTableActionProps {
    foodOrderId: any;
  onDelete: (id: number) => void;
}

export const AllFoodOrderTableAction: React.FC<ProductListTableActionProps> = ({ foodOrderId, onDelete }) => {

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, update it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(foodOrderId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <button className="btn btn-xs btn-danger" title="Update Order Status" onClick={handleDeleteClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 7v4H6.83l3.59-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21V7z"/>
        </svg>
      </button>
    </div>
  );
};

export const AllFoodOrderTableProductName: React.FC<AllFoodOrderTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const AllFoodOrderTableStatus :React.FC<AllFoodOrderTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const allFoodOrderTableDataColumn: TableColumn<AllFoodOrderTableDataColumnType>[] = [
  {
    name: "Ticket ID",
    cell: (row) => <AllFoodOrderTableProductName title={row.ticketRFIdRef}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "RFID Card No.",
    selector: (row) => `${row.cardNumber}`,
    sortable: true,
    grow: 2,
  },
  {
    name: "Total Amount",
    selector: (row) => `${row.subTotalAmount}`,
    sortable: true,
  },
  {
    name: "GST",
    selector: (row) => `${row.gst}`,
    sortable: true,
  },
  {
    name: "Grand Total Amount",
    selector: (row) => `${row.grandTotalAmount}`,
    sortable: true,
  },
  {
    name: "Status",
    cell: (row) =>  <AllFoodOrderTableStatus title={row.status} />,
  },
  {
    name: "Action",
    cell: (row) => <AllFoodOrderTableAction foodOrderId={row.foodOrderId} onDelete={handleDelete} />,
  },
  ];

  export const filtersData = [
    {
      name: "Choose Ticket ID",
      options: ["SWP-4893", "SWP-2311"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "customerMobileNumber",
      options: ["8347821920"],
    },
  ];